import { server_ip } from "../config";

export async function participateEvent(token,eventId,data=null,sendEmail=true){
    try {
        const response= await fetch(`${server_ip}/api/eventParticipations/`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                iswebregistration: sendEmail,
            },
            body: JSON.stringify({
                eventId,
                data,
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function merchantFetchParticipationWithUserData(token,filter,options,userFilter){
    try {
        const response= await fetch(`${server_ip}/api/eventParticipations/merchant/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options,
                userFilter
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function merchantChangeParticipationStatus(token,userId,eventId,status){
    try {
        const response= await fetch(`${server_ip}/api/eventParticipations/merchant/approve`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                userId,
                eventId,
                status
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function merchantAddRemarks(token,userId,eventId,remarks){
    try {
        const response= await fetch(`${server_ip}/api/eventParticipations/merchant/remarks`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                userId,
                eventId,
                remarks
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}

export async function checkIfEmailRegisteredEvent(eventId,email){
    try {
        const response= await fetch(`${server_ip}/api/eventParticipations/check/register`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email,
                eventId
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}

export async function fetchEvents(filter,options){
    try {
        const response= await fetch(`${server_ip}/api/events/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function fetchEventById(id){
    try {
        const response= await fetch(`${server_ip}/api/events/${id}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function insertEvent(token,data){
    try {
        const response= await fetch(`${server_ip}/api/events/`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function updateEvent(token,id,data){
    try {
        const response= await fetch(`${server_ip}/api/events/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function fetchEventComments(filter,options){
    try {
        const response= await fetch(`${server_ip}/api/eventComments/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}
export async function fetchEventScanCounts(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api/eventScanCounts/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}

export async function deleteEvent(token,id){
    try {
        const response= await fetch(`${server_ip}/api/events/${id}`,{
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}

export async function importEventParticipations(token,id,dataArray){
    try {
        const response= await fetch(`${server_ip}/api/eventParticipations/import/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                dataArray
            })
        })
        return await response.json();
    } catch (error) {
        return {errno:1,message:'Unexpected error'}
    }
}